import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
export const Input = styled.input.attrs((props) => ({
    style: {
        width: props.width !== undefined ? pxToRem(Number(props.width)) : undefined,
    },
})) `
  box-sizing: content-box;
`;
export const Sizer = styled.div `
  position: absolute;
  visibility: hidden;
  overflow: scroll;
  white-space: pre;
  top: 0;
  left: 0;
  height: 0;
`;
